export class UploadBatchNativeValidationReport {
    public runReportDateTime: string;
    public missingPdfFileCount: number;
    public failedToIndexDocCount: number;
    public missingUncompressedDocCount: number;
    public missingOriginalFileCount: number;
    public failedToConvertExceedsThershold: boolean;
    public unsupportedFileTypeCount: number;
    public failedToConvertCount: number;
    public pageCountThresholdCount: number;

    public hasErrors(): boolean {
        return (this.missingPdfFileCount > 0)
            || (this.missingUncompressedDocCount > 0)
            || (this.missingOriginalFileCount > 0);
    }

    public hasWarnings(): boolean {
        return (this.failedToIndexDocCount > 0);
    }

    public hasInfo(): boolean {
        return (this.unsupportedFileTypeCount > 0)
            || (this.pageCountThresholdCount > 0)
            || this.failedToConvertExceedsThershold;
    }
}